<template>
    <b-card no-body>
        <b-modal id="create-or-update" size="md" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <parent-firm-create-or-update v-model="parentFirm"></parent-firm-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
    
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    search
                    :buttons="buttons"
                    :add-callback="createNew"
                    pagination="server">
        </v-table>
    </b-card>
</template>

<script>
import ParentFirmCreateOrUpdate from './components/ParentFirmCreateOrUpdate.vue'
import { BCard } from 'bootstrap-vue'
import FirmOperationsApi from '@/api/firm-operations'

export default {
    components:{
        ParentFirmCreateOrUpdate,
        BCard
    },
    data(){
        return {
            fields:[
                {name:'Kısa Kod',key:'ParentFirmShortName',thClass:'w-25'},
                {name:'Ana Firma',key:'Name',thClass:'w-75'}
            ],
            parentFirm:{
				Id:null,
				ParentFirmName:null,
				ParentFirmShortName:null
			},
            buttons:[
                { text:"Düzenle",key:"edit-firm-info",icon:"Edit2Icon",variant:"primary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            loading:false
        }
    },
    methods:{
        provider(data){
            return FirmOperationsApi.ParentFirm.Table(data)
        },
        clearForm(){
			this.parentFirm.Id = null
			this.parentFirm.ParentFirmName = null
			this.parentFirm.ParentFirmShortName = null
		},
        createNew(){
			this.clearForm()
			this.$showModal('create-or-update')
		},
		edit(item){
			this.clearForm()
			this.editing = true
			this.parentFirm.Id = item.Id 
			this.parentFirm.ParentFirmName = item.Name 
			this.parentFirm.ParentFirmShortName = item.ParentFirmShortName
			this.$showModal('create-or-update')
		},
		createOrUpdate(){
			this.loading = true
			FirmOperationsApi.ParentFirm.CreateOrUpdate(this.editing,this.parentFirm).then(res=>{
				this.loading = false
				this.$result(res)
				if(res.data.Success){
					this.$hideModal('create-or-update')
					this.$refs.table.refresh()
				}
			}).catch(err=>{
				this.$result(null,err)
				this.loading = false
			})
		},
        delete(item){
			this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli ana firmayı ve bağlı firmaları silecektir, geri alınamaz.`).then(result=>{
                if(result){
                    FirmOperationsApi.ParentFirm.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
		},
    }
}
</script>

<style>

</style>